import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'dealer-invalid-url',
  templateUrl: './invalid-url.component.html',
  styleUrls: ['./invalid-url.component.scss']
})
export class InvalidUrlComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
